import { Component } from '@angular/core';
import { IonicPage, ViewController, NavParams, NavController } from 'ionic-angular';

import { DeviceType, Message, MessageVisibility } from '../../models/models';
import { AuthProvider } from '../../providers/auth/auth';
import { DeviceProvider } from '../../providers/device/device';
import { MessageCreatePage } from '../message-create/message-create';

@IonicPage()
@Component({
	selector: 'page-message-modal',
	templateUrl: 'message-modal.html',
})
export class MessageModalPage {
	private dismissTimeout: number = null;
	message: Message;

	constructor(
		public devices: DeviceProvider,
		public viewCtrl: ViewController,
		public auth: AuthProvider,
		public nav: NavController,
		public navParams: NavParams
	) {
		//this.url=navParams.get('url');
		this.message = <Message>navParams.get('message');
	}

	public dismiss() {
		this.viewCtrl.dismiss()
	}

	public onError(error) {
		console.error('Errore visualizzando il messaggio ' + this.message, error);
	}

	ionViewDidLeave() {
		//evitiamo di chiudere se già chiuso
		let timeout = this.dismissTimeout
		if (timeout) {
			clearTimeout(timeout);
		}
	}
	/**
	Va in primo piano
	*/
	ionWillEnter() {
		//se deve imposta un timeout di autochiusura
		let actualType = this.devices.actualType;
		console.log('Aprendo modale, tipo del dispositivo attuale:', actualType);
		if (actualType == DeviceType.INTERCOM || actualType == DeviceType.DASHBOARD) {
			console.log('Device pubblico, chiusura automatica modale dopo 60 secondi');
			let self = this;
			this.dismissTimeout = setTimeout(() => {
				self.dismissTimeout = null;
				self.viewCtrl.dismiss()
			}, 60000);
		}
	}

	/**
	Rispondi a bacheca
	*/
	public replyToDashboard() {
		this.nav.push(MessageCreatePage, {
			subject: 'Segnalazione ricevuta: ' + this.message.subject,
			body: 'Ricevuta segnalazione:\n\n"' + this.message.body + '"',
			condominium: this.message.condominium,
			visibility: MessageVisibility.PUBLIC
		})
		//chiude il modale in uscita
		this.viewCtrl.dismiss()
	}
}



// WEBPACK FOOTER //
// ./src/pages/message-modal/message-modal.ts